/**
 * Role: Apply embed script and style for Shadow Dom
 * Using global variables: _lang
 */
'use strict'

const applyEmbedFormStyles = () => {
  const doc = document.documentElement;
  const host = document.querySelector("#app-embed");
  if (!host || !host.shadowRoot) return false;

  const form = host.shadowRoot.querySelector('form');
  if (!form) return false;

  const wrapper = form.closest('section');
  if (wrapper) wrapper.style.maxWidth = '610px';

  const elementContainers = form.querySelectorAll(':scope > div');

  elementContainers.forEach(container => {
    const hasInputs = container.querySelector('input, select, button');
    container.style.flexBasis = hasInputs ? 'calc(50% - 0.5rem)' : '100%';
  });

  const WHATSAPP_HTML = `<button type="button" class="whatsapp-chat" name="WhatsApp_Chat">
    <a title="WhatsApp" href="https://wa.me/+436641570065" target="_blank" rel="noopener noreferrer">WhatsApp Chat</a>
  </button>`;

  const ICON_UPLOAD = `<svg class="icon upload" style="width:1.25em; height:auto;" xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
    <path d="M18.22 20.75H5.78C5.43322 20.7359 5.09262 20.6535 4.77771 20.5075C4.4628 20.3616 4.17975 20.155 3.94476 19.8996C3.70977 19.6442 3.52745 19.3449 3.40824 19.019C3.28903 18.693 3.23525 18.3468 3.25 18V15C3.25 14.8011 3.32902 14.6103 3.46967 14.4697C3.61033 14.329 3.80109 14.25 4 14.25C4.19892 14.25 4.38968 14.329 4.53033 14.4697C4.67099 14.6103 4.75 14.8011 4.75 15V18C4.72419 18.2969 4.81365 18.5924 4.99984 18.8251C5.18602 19.0579 5.45465 19.21 5.75 19.25H18.22C18.5154 19.21 18.784 19.0579 18.9702 18.8251C19.1564 18.5924 19.2458 18.2969 19.22 18V15C19.22 14.8011 19.299 14.6103 19.4397 14.4697C19.5803 14.329 19.7711 14.25 19.97 14.25C20.1689 14.25 20.3597 14.329 20.5003 14.4697C20.641 14.6103 20.72 14.8011 20.72 15V18C20.75 18.6954 20.5041 19.3744 20.0359 19.8894C19.5677 20.4045 18.9151 20.7137 18.22 20.75Z" fill="currentColor"/>
    <path d="M16 8.74995C15.9015 8.75042 15.8038 8.7312 15.7128 8.69342C15.6218 8.65564 15.5392 8.60006 15.47 8.52995L12 5.05995L8.53 8.52995C8.38782 8.66243 8.19978 8.73455 8.00548 8.73113C7.81118 8.7277 7.62579 8.64898 7.48838 8.51157C7.35096 8.37416 7.27225 8.18877 7.26882 7.99447C7.2654 7.80017 7.33752 7.61213 7.47 7.46995L11.47 3.46995C11.6106 3.3295 11.8012 3.25061 12 3.25061C12.1987 3.25061 12.3894 3.3295 12.53 3.46995L16.53 7.46995C16.6705 7.61058 16.7493 7.8012 16.7493 7.99995C16.7493 8.1987 16.6705 8.38932 16.53 8.52995C16.4608 8.60006 16.3782 8.65564 16.2872 8.69342C16.1962 8.7312 16.0985 8.75042 16 8.74995Z" fill="currentColor"/>
    <path d="M12 15.75C11.8019 15.7474 11.6126 15.6676 11.4725 15.5275C11.3324 15.3874 11.2526 15.1981 11.25 15V4C11.25 3.80109 11.329 3.61032 11.4697 3.46967C11.6103 3.32902 11.8011 3.25 12 3.25C12.1989 3.25 12.3897 3.32902 12.5303 3.46967C12.671 3.61032 12.75 3.80109 12.75 4V15C12.7474 15.1981 12.6676 15.3874 12.5275 15.5275C12.3874 15.6676 12.1981 15.7474 12 15.75Z" fill="currentColor"/>
  </svg>`;

  const ICON_CHEVRON = `<svg class="icon chevron-down" xmlns="http://www.w3.org/2000/svg" width="16" height="9" viewBox="0 0 16 9" fill="none">
    <path d="M0.749999 0.749951L7.95 7.94995L15.15 0.749949" stroke="#7F8790" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
  </svg>`;

  const btnSubmit = form.querySelector('button[type="submit"]');

  if (btnSubmit && !btnSubmit.hasAttribute('data-whatsapp')) {
    btnSubmit.insertAdjacentHTML('afterend', WHATSAPP_HTML);
    btnSubmit.dataset.whatsapp = 'true';
  }

  const inputFile = form.querySelector('input[type="file"]');
  
  const inputFileButton = inputFile ? inputFile.closest('button[type="button"]') : null;
  
  let resetFile = inputFileButton ? inputFileButton.querySelector('div>button[type="button"]') : null;
  
  const productUrlInput = form.querySelector('input[data-testid="field-custom#product_url"]');
  const productUrlInputContainer = productUrlInput ? productUrlInput.closest('._formFieldContainer_1mxsl_5 ') : null;
  if (productUrlInputContainer) productUrlInputContainer.style = 'display: none;';

  const svg = form.querySelectorAll('svg');
  svg.forEach(el => {
    if (el.closest('[aria-controls="country-selector-dropdown"], [aria-controls="custom#watch_brand-selector-dropdown"]')) el.parentElement.innerHTML = ICON_CHEVRON;
  });

  if (inputFileButton) {
    inputFileButton.classList.add('input-file-button');
  }

  let inputFilePlaceholder = inputFile?.closest('button')?.querySelector('p:not([data-icon-processed="true"])') ?? null;
  if (inputFilePlaceholder) {

    function changePlaceholder() {
      inputFilePlaceholder.classList.add('input-file-placeholder');
      inputFilePlaceholder.insertAdjacentHTML('beforeend', ICON_UPLOAD);
      inputFilePlaceholder.setAttribute('data-icon-processed', true);
    }
    changePlaceholder();

    form.addEventListener('change', () => {
      resetFile = inputFileButton ? inputFileButton.querySelector('div>button[type="button"]') : null;
      inputFilePlaceholder = inputFile ? inputFile.closest('button').querySelector('p:not([data-icon-processed="true"])') : null;

      if (inputFilePlaceholder) changePlaceholder();

      if (resetFile) {
        resetFile.addEventListener('click', () => {
          inputFilePlaceholder = inputFile ? inputFile.closest('button').querySelector('p:not([data-icon-processed="true"])') : null;

          if (inputFilePlaceholder) changePlaceholder();
        });
      }
    });
  }

  const inputFileLabel = inputFileButton ? inputFileButton.parentElement.firstChild : null;
  if (inputFileLabel) inputFileLabel.style.display = 'none';

  /** Country code select */
  function countryCodeSelect() {
    const buttons = form.querySelectorAll('button._selectToggle_12thd_25');
    if (!buttons.length) return;

    const PLACEHOLDERS_CONFIG = {
      de: 'Geben Sie die ersten Buchstaben ein',
      en: 'Enter the first letters',
      // ***
    };

    const PLACEHOLDER = PLACEHOLDERS_CONFIG[_lang] ?? PLACEHOLDERS_CONFIG['en'];
    const RESET_DELAY = 3000;
    const DROPDOWN_DELAY = 100;

    let resetTimer = null;
    
    buttons.forEach(btn => {
      btn.addEventListener('click', () => {
        let listenerAttached = false;
        setTimeout(() => {
          const parent = btn.querySelector('div._dropdownContainer_12thd_63');
          if (!parent) return;

          if (!parent.dataset.insertProcessed) {
            parent.insertAdjacentHTML(
              'afterbegin',
              `<span id="country-selector" class="country-selector-hint">${PLACEHOLDER}</span>`
            );
            parent.dataset.insertProcessed = 'true';
          }

          const textContainer = btn.querySelector('#country-selector');
          if (!textContainer || listenerAttached) return;

          listenerAttached = true;
          parent.addEventListener('keydown', (e) => {
            const isLetter = /^[a-zA-ZäöüÄÖÜß]$/.test(e.key); // EN + DE
            if (!isLetter) return;

            if (textContainer.textContent === PLACEHOLDER) textContainer.textContent = ''; 
            textContainer.textContent += e.key;

            clearTimeout(resetTimer);
            resetTimer = setTimeout(() => {
              textContainer.textContent = PLACEHOLDER;
            }, RESET_DELAY);
          });
        }, DROPDOWN_DELAY);
      });
    });
  }
  countryCodeSelect();

  /** Add custom sheet */
  const myCustomSheet = new CSSStyleSheet();

  myCustomSheet.replaceSync(`
    @media screen and (min-width: 991px) {
      :host form {
        display: flex;
        flex-flow: wrap;
        justify-content: center;
        gap: 1rem;
      }
    }

    :host button:where([aria-controls="country-selector-dropdown"], [aria-controls="custom#watch_brand-selector-dropdown"]) svg:not(.icon) path {
      fill: #7F8790;
    }

    :host button#custom\#upload_photo-label {
    }

    :host label._formInputFieldLabel_1mxsl_38 {
      line-height: 0;
    }

    :host .input-file-button {
      height: 48px;
      padding: 4px 0px;
      margin-block: 0;
      padding: 0;
      display: flex;
      align-items: center;
    }

    :host .input-file-placeholder {
      margin-block: 0; 
      background: none transparent;
      display: flex;
      gap: 0.25em;
    }

    :host output[role="alert"] {
      color: white;
      background-color: var(--form-error-color);
      margin: 0;
      padding: 5px 10px;
      box-shadow: 4px 4px 24px #00000057;
      position: absolute;
      top: -1px;
      z-index: 3;
      -webkit-border-radius: 1px;
      -moz-border-radius: 1px;
      -ms-border-radius: 1px;
      -o-border-radius: 1px;
      border-radius: 1px;
    }

    :host form>div>p {
      pointer-events: none;
      z-index: 1;
      line-height: 1.3;
      color: var(--form-placeholder-color);
      position: absolute;
      left: var(--form-field-padding);
      top: var(--input-label-top);
      max-width: calc(100% - var(--form-field-padding) * 2);
      word-break: keep-all;
      overflow-wrap: break-word;
      transform-origin: left top;
      transform: none;
      margin: 0px;
      -webkit-transition: 200ms cubic-bezier(0, 0, 0.2, 1);
      -moz-transition: 200ms cubic-bezier(0, 0, 0.2, 1);
      -ms-transition: 200ms cubic-bezier(0, 0, 0.2, 1);
      -o-transition: 200ms cubic-bezier(0, 0, 0.2, 1);
      transition: 200ms cubic-bezier(0, 0, 0.2, 1);
    }

    ._dropdownContainer_12thd_63 div:hover,
    ._dropdownContainer_12thd_63 div,
    ._dropdownContainer_12thd_63 {
      -webkit-border-radius: 1px !important;
      -moz-border-radius: 1px !important;
      -ms-border-radius: 1px !important;
      -o-border-radius: 1px !important;
      border-radius: 1px !important;
    }

    :host button[aria-controls="custom#watch_brand-selector-dropdown"]>:first-child {
      background-color: var(--form-background-color);
      line-height: 1.5;
      z-index: 2;
    }

    :host :is(input, select, textarea, button) {
      border-radius: 1px;
    }

    :host ._formFileInput_ehvsf_1 {
      flex-basis: 100% !important;
    }

    :host input[type="tel"] {
      -webkit-border-radius: 2px;
      -moz-border-radius: 2px;
      -ms-border-radius: 2px;
      -o-border-radius: 2px;
      border-radius: 2px;
    }

    :host button[aria-controls="country-selector-dropdown"] {
      position: static;
      height: 100%;
      max-height: none;
      padding: 0.5em 1em;
    }

    :host .phone-country-selector>div {
      height: 100%;
    }

    :host button[type="submit"] {
      background-color: #1a1a1a;
      min-width: 200px;
      align-items: center;
      text-transform: uppercase;
      -webkit-border-radius: 2px;
      -moz-border-radius: 2px;
      -ms-border-radius: 2px;
      -o-border-radius: 2px;
      border-radius: 2px;
    }

    :host button {
      -webkit-transition: background-color .2s;
      -moz-transition: background-color .2s;
      -ms-transition: background-color .2s;
      -o-transition: background-color .2s;
      transition: background-color .2s;
    }

    :host button[type="submit"]:hover {
      background-color: #44545b;
    }

    :host .whatsapp-chat {
      font-family: inherit;
      color: inherit;
      text-decoration: none;
      text-transform: uppercase;
      cursor: pointer;
      display: inline-flex;
      min-width: 200px;
      height: 48px;
      padding: 0;
      border-style: solid;
      background-color: transparent;
      border-color: currentColor;
      border-width: 1.5px;
      -webkit-border-radius: 2px;
      -moz-border-radius: 2px;
      -ms-border-radius: 2px;
      -o-border-radius: 2px;
      border-radius: 2px;
    }

    :host .whatsapp-chat:hover {
      background-color: #fff;
    }

    :host .whatsapp-chat a {
        color: inherit;
        font-family: inherit;
        text-decoration: inherit;
        width: 100%;
        height: 100%;
        display: flex;
        align-items: center;
        justify-content: center;
    }

    .icon.chevron-down {
      width: 12px;
      height: auto;
    }

    :host button svg.upload {
      margin-bottom: 2px;
    }

    :host :is(a, button, input) {
      word-spacing: 0.3em;
    }

    :host .country-selector-hint {
      font-size: 12px;
      color: #44545b;
      background: #f2f2f6;
      text-align: center;
      padding: 4px;
      position: absolute;
      top: 0;
      left: 0;
      right: 0;
      pointer-events: none;
    }

    :host ._dropdownContainer_12thd_63 {
      padding-top: 2rem;
    }

  `);

  const hostElement = document.querySelector('#app-embed');
  console.log('hostElement', hostElement !== null);

  if (hostElement && hostElement.shadowRoot) {
    const shadow = hostElement.shadowRoot;
    shadow.adoptedStyleSheets = [...shadow.adoptedStyleSheets, myCustomSheet];
  }
  /** end Add custom sheet */

  return true;
}

const initEmbedModifications = () => {
  const POLLING_INTERVAL_MS = 100;
  const MAX_ATTEMPTS = 40; // 40 trials * 100ms = 4 seconds recovery
  let attempts = 0;

  const pollingInterval = setInterval(() => {
    attempts++;
    
    const host = document.querySelector("#app-embed");
    const form = host?.shadowRoot?.querySelector('form');
    const btnSubmit = form?.querySelector('button[type="submit"]');

    if (form && btnSubmit) {
      // Success! If all critical elements have been rendered
      clearInterval(pollingInterval);
      applyEmbedFormStyles(); 
      return;
    }

    if (attempts >= MAX_ATTEMPTS) {
      clearInterval(pollingInterval);
      console.warn('Embed modification timeout: Shadow DOM or form not found.');
    }
  }, POLLING_INTERVAL_MS);
};

['DOMContentLoaded', 'shopify:section:load'].forEach(event =>
  document.addEventListener(event, initEmbedModifications)
);
